import { getAIHook } from '@openclassrooms/data-connect-web/utils';

const useSuggestFields = getAIHook<{ language: 'fr' | 'en'; type: 'training' | 'profession' }>({
  promptCode: 'suggest-fields',
  serverName: 'ai-api-user',
});

export default useSuggestFields;
